// NOTICE: This file was copied from the oppizi-shared repository, do
// not modify it here.

// See unit tests for example I/O
import { InvalidRequest } from '../error'
import { replaceDeprecatedFields } from './../misc'

/**
 * Determines if the surge amount can be claimed or not
 * @param {Mission} mission
 * @param {number} surgeInterval
 * @returns {boolean}
 */
export const canClaimSurge = (mission, surgeInterval) => {
  mission = replaceDeprecatedFields({
    deprecatedFieldsToNewFieldsMap: {
      timeRangeStart: 'dateTime',
      checkinTime: 'checkInTime',
    },
    data: mission,
  })

  if (!surgeInterval) throw new InvalidRequest('Missing surgeInterval')
  if (!mission.dateTime)
    throw new InvalidRequest('Missing mission.timeRangeStart')
  if (!mission.checkInTime) return false

  const minsDiff =
    (new Date(mission.checkInTime) - new Date(mission.dateTime)) / 1000 / 60 // in minutes

  if (minsDiff >= 0) return minsDiff <= surgeInterval + 1
  return minsDiff * -1 <= surgeInterval + 1
}

export const convertUnitsToCents = val => val * 100
export const convertCentsToUnits = val => val / 100



// WEBPACK FOOTER //
// ./src/shared/libraries/finance.js